import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrap = styled.div`
  margin: 50px auto 30px auto;
  padding: 10px;
  max-width: 1250px;
`;
const Title = styled.p`
  font-family: "Lato Bold", sans-serif;
  font-size: 44px;
  line-height: 44px;
  font-weight: 700;
  color: #444;
  text-align: center;
`;
const Content = styled.div`
  display: flex;
  margin: 50px 0 0 0;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;
const Img = styled.img`
  flex: 1;
  position: sticky;
  top: 80px;
  left: 0;
  max-width: 50%;
  height: 100%;

  @media (max-width: 1000px) {
    position: initial;
    padding: 0 25px;
    max-width: initial;
    width: 100%;
    height: initial;
  }
`;
const Items = styled.div`
  flex: 1;
  padding: 0 0 0 20px;
  width: 70%;

  @media (max-width: 1000px) {
    padding: 0;
    margin: 30px 0 0 0;
    width: initial;
  }
`;
const Item = styled.div`
  position: relative;
  background-color: white;
  border-radius: 10px;
  padding: 40px 50px 40px 75px;
  margin-bottom: 20px !important;
`;
const ItemId = styled.p`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 35px;
  left: 25px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  color: white;
  border-radius: 50%;
  background-color: #971b2f;
`;
const ItemTitle = styled.p`
  margin: 0 0 10px 0;
  font-family: "Hind", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #444;
`;
const ItemDesc = styled.p`
  line-height: 24px;
  font-family: "Hind", sans-serif;
  font-size: 16px;
  color: #676767;
`;

export type THow = {
  title: string;
  img: string;
  items: {
    title: string;
    desc: string;
  }[];
};

export type TProps = {
  how: THow;
};

export default function How(props: TProps) {
  const { t } = useTranslation();

  return (
    <Wrap>
      <Title data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="200" data-aos-duration="500">
        {t(props.how.title)}
      </Title>
      <Content>
        <Img src={props.how.img} />
        <Items>
          {props.how.items.map((v, i) => (
            <Item key={i}>
              <ItemId>{i + 1}</ItemId>
              <ItemTitle>{t(v.title)}</ItemTitle>
              <ItemDesc>{t(v.desc)}</ItemDesc>
            </Item>
          ))}
        </Items>
      </Content>
    </Wrap>
  );
}
